import { type RefObject, useEffect, useState } from 'react';

/**
 * 요소의 아래 끝이 화면 맨 위에서 offset(px) 지점보다 위로 올라갔는지 — 스크롤로 그 요소를 지나쳤는지 판단한다.
 * 레이아웃을 바꾸지 않고 위치만 읽으므로, 이 값으로 화면을 바꿔도 스크롤 위치가 튀지 않는다.
 */
export const useScrolledAbove = (ref: RefObject<HTMLElement | null>, offset = 0): boolean => {
  const [isAbove, setIsAbove] = useState(false);

  useEffect(() => {
    const update = (): void => {
      const element = ref.current;
      setIsAbove(element !== null && element.getBoundingClientRect().bottom <= offset);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [ref, offset]);

  return isAbove;
};
